<template>
    <div v-if="value">
        <input
            type="text"
            autocomplete="country"
            v-model="value.country"
            data-enpassusermodified="yes"
            id="country-auto"
            style="opacity: 0; height: 0;"
        />
        <v-text-field
            v-model="value.name"
            :label="$t('label.name')"
            required
            :rules="[required]"
            type="text"
            autocomplete="name"
            filled
        >
        </v-text-field>
        <v-text-field
            v-model="value.company"
            :label="$t('label.company')"
            type="text"
            autocomplete="organization"
            filled
        >
        </v-text-field>

        <v-textarea
            v-model="value.address"
            :label="$t('label.address')"
            type="text"
            required
            :rules="[required]"
            autocomplete="street-address"
            rows="2"
            filled
        >
        </v-textarea>
        <v-row>
            <v-col sm="4">
                <v-text-field
                    v-model="value.zip"
                    :label="$t('label.zip')"
                    type="text"
                    required
                    :rules="[required]"
                    autocomplete="postal-code"
                    filled
                >
                </v-text-field>
            </v-col>
            <v-col>
                <v-text-field
                    v-model="value.city"
                    :label="$t('label.city')"
                    type="text"
                    required
                    :rules="[required]"
                    autocomplete="address-level2"
                    filled
                >
                </v-text-field>
            </v-col>
        </v-row>

        <ApolloQuery :query="require('@/graphql/utils/countries.gql')" :variables="{ locale }">
            <template slot-scope="{ result: { data, loading } }">
                <v-autocomplete
                    class="mb-0"
                    v-if="(data ? data.countries : []).length > 0 || loading"
                    v-model="value.country"
                    :items="data ? data.countries : []"
                    item-value="code"
                    item-text="name"
                    :loading="loading"
                    required
                    :label="$t('label.country')"
                    autocomplete="off"
                    :rules="[required]"
                    filled
                ></v-autocomplete>
            </template>
        </ApolloQuery>
        <v-text-field
            v-model="value.phoneNumber"
            :label="$t('label.phone_number')"
            hint="+41 12 345 67 89"
            type="text"
            autocomplete="tel"
            persistent-hint
            validate-on-blur
            @blur="formatPhone"
            :rules="[validatePhoneNumber]"
            filled
        >
        </v-text-field>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { formatIncompletePhoneNumber, isValidNumber } from "libphonenumber-js"
export default {
    computed: {
        ...mapGetters({
            locale: "user/locale",
        }),
    },
    props: {
        value: {
            type: Object,
        },
    },

    methods: {
        required(value) {
            return !!value || this.$t("error.required")
        },
        validatePhoneNumber(v) {
            if (v && isValidNumber(v)) {
                return true
            }
            return this.$t("error.not_valid_phone_number")
        },
        formatPhone() {
            this.value.phoneNumber = formatIncompletePhoneNumber(this.value.phoneNumber)
        },
    },
    mounted() {
        if (!this.value) {
            this.$emit("input", {
                name: null,
                company: "",
                address: null,
                zip: null,
                city: null,
                phoneNumber: null,
                country: null,
            })
        }
    },
    watch: {
        value() {
            this.$emit("input", this.value)
        },
    },
}
</script>

<style></style>
